import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { RouteCardItemExpandDto } from '@shared/src/dtos/route/RouteCardItemExpandDto';
import { RouteController } from '@shared/src/public-api';

@Component({
    selector: 'shared-forklift-right-route',
    templateUrl: './shared.forklift.right.route.component.html',
    styleUrls: ['./shared.forklift.right.route.component.scss']
})
export class SharedForkliftRightRouteComponent implements OnChanges {

    constructor(private routeController: RouteController) { }

    @Output() public refresh = new EventEmitter<boolean>();

    @Input() public detail: ForkliftRouteDetailDto | null = null;
    public options: OptionsStripDto | null = null;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['detail']) {
            if (this.detail) {
                this.options = OptionsStripDto.sync(this.detail.options, this.options);
                this.option = this.options.getActualSelected()?.optionId;
            } else {
                this.options = null;
                this.option = null;
                this.route = null;
            }
        }
    }

    public option: string | null = null;
    public route: RouteCardItemExpandDto | null = null;

    onClickOption(option: OptionDto) {
        this.option = option.optionId;
        if (this.detail != null && 'DRIVERPLATE' === this.option)
            this.routeController.getRouteCardItemExpand(this.detail.routeId).subscribe(d => {
                this.route = d;
            });
    }

    onRouteRefresh($event: boolean) {
        if (this.detail != null && 'DRIVERPLATE' === this.option)
            this.routeController.getRouteCardItemExpand(this.detail.routeId).subscribe(d => {
                this.route = d;
            });
        this.refresh.next($event);
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
